<section class="request-extension-dialog">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white request-extension-dialog-header">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{requestExtensionDialogData?.title || 'Request Extension'}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <mat-dialog-content>
        <div class="my-dialog-content">
            @if (!isSuccess()) {
            <div class="md-dialog-content">
                <!-- Original -->
                <h4 class="md-subhead">CURRENT DUE DATE</h4>

                <div class="top-padding uscb-margin-L-15">
                    <i class="fa fa-calendar"></i>&nbsp;&nbsp;
                    <span>Due - </span>
                    <span
                        [ngClass]="{'strike-gr': currentOriginalDueDate()?.getDate() !== currentMostRecentDueDate()?.getDate()}">{{currentOriginalDueDate() | date:'M/d/yyyy'}}</span>
                    @if (currentOriginalDueDate()?.getDate() !== currentMostRecentDueDate()?.getDate()) {
                    <span>, {{currentMostRecentDueDate() | date:'M/d/yyyy'}}</span>
                    }
                </div>

                <h4 class="md-subhead top-padding">EXTENDED DUE DATE</h4>

                <form [formGroup]="formGroup" class="uscb-layout-column uscb-form">
                    <div class="uscb-layout-row uscb-layout-align-flex-start uscb-layout-align-vert-stretch">
                        <mat-datepicker-toggle #pickertoggle1 matPrefix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1 [disabled]="currentDateError() !== ''"></mat-datepicker>
                        <input matInput [matDatepicker]="picker1" formControlName="extendedDueDate" [min]="currentMinExtendedDueDate()"
                            [(ngModel)]="extendedDueDate" [max]="currentMaxExtendedDueDate()" aria-label="extended due date" readonly 
                            (click)="picker1.open()" (keyup.enter)="picker1.open()" tabindex="0">
                    </div>
                    @if (formGroup.invalid && currentDateError() === '') {
                    <mat-error class="red-text-darker">
                        A valid date is between {{currentMinExtendedDueDate() | date: 'M/d/yyyy'}} and {{currentMaxExtendedDueDate() | date: 'M/d/yyyy'}}.
                    </mat-error>
                    }
                    @if (currentDateError() !== '') {
                    <div class="red-text-darker">
                        {{currentDateError()}}
                    </div>
                    }
                </form>
            </div>
            }
            @if (isSuccess()) {
            <div class="md-dialog-content">
                <h4 class="xlg-text bottom-padding-sm">Success! Your time extension has been granted!</h4>
                <span class="md-text uscb-layout-column">{{currentSuccessMessage()}} {{currentExtensionMessageDate() | date:'M/d/yyyy'}}. Your survey card has been
                    updated with this information.</span>
                <br>
                <span class="md-text top-padding"><b>IMPORTANT NOTE: </b>If the survey due date is extended, your personal calendar will not sync automatically.</span>
            </div>
            }
            @if (currentExtensionError()) {
            <div class="red-text">{{currentExtensionError()}}</div>
            }
        </div>
    </mat-dialog-content>

    @if (!isSuccess()) {
    <mat-dialog-actions
        class="request-extension-dialog-actions uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-secondary-button uscb-flex-row uscb-margin-LR-10"
            (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{requestExtensionDialogData?.cancelButtonLabel || 'Cancel'}}</button>
        @if (!isRequestExtensionButtonDisabled()) {
        <button type="submit" [disabled]="formGroup.invalid || currentDateError() !== ''"
            class="uscb-primary-button uscb-flex-row" (click)="confirm()" (keyup.enter)="confirm()" tabindex="0">{{requestExtensionDialogData?.confirmButtonLabel || 'Submit'}}</button>
        }
        @if (isRequestExtensionButtonDisabled()) {
        <button type="button" disabled class="uscb-primary-button uscb-flex-row">
            <i class="fa fa-spinner fa-spin fa-lg"></i>&nbsp;&nbsp; Please wait...</button>
        }
    </mat-dialog-actions>
    }
    @if (isSuccess()) {
    <mat-dialog-actions
        class="request-extension-dialog-actions uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-primary-button" (click)="ok()" (keyup.enter)="ok()" tabindex="0">OK</button>
        @if (isExporting()) {
        <ng-container>
            <div class="cursor-progress"> Please wait. Exporting... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
            </div>
        </ng-container>
        }
        @if (!isExporting()) {
        <ng-container>
            <button aria-label="export to calendar" type="button" class="uscb-transparent-button uscb-margin-0 uscb-padding-TB-0 uscb-paddding-LR-5"
            (click)="exportSurvey()" (keyup.enter)="exportSurvey()" tabindex="0">
                <i class="fa fa-calendar"></i> Export to Calendar
            </button>
        </ng-container>
        }
    </mat-dialog-actions>
    }

</section>